'use strict';

export default ['$scope', '$uibModalInstance', 'transaction',
    function ($scope, $modalInstance, transaction) {
        $scope.transaction = transaction;
        
        $scope.ok = function () {
            $modalInstance.close($scope.transaction);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }]; 